import script from "./RechargeAmounts.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeAmounts.vue?vue&type=script&setup=true&lang=js"

import "./RechargeAmounts.vue?vue&type=style&index=0&id=c0a98814&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0a98814"]])

export default __exports__